import { createReducer, on } from "@ngrx/store";
import {
  agregarEditarObservacionesAcuerdo,
  agregarNuevaEntrada,
  agregarNuevaEntradaSuccess,
  agregarNuevoTema,
  cargarEntregablesArchivosSuccess,
  cargaTemasAcuerdo,
  dragArchivosTema,
  dragEntrada,
  dragEntrregablesTema,
  eliminarArchivoAcuerdo,
  eliminarArchivoAdjunto,
  eliminarEntrada,
  eliminarTemaMrb,
  nuevoActualizarIndicacion,
  nuevosArchivosAcuerdo,
  realizarAcuerdo,
  resetTemasAcuerdo,
  resetTemasDejarAcuerdo,
  toggleExpandTema,
  updateFechaAcuerdo,
  updateTemaForm,
} from "./actions";
import { IStateAcuerdoSeleccionado } from "../../interfaces/temas";
import {
  IAcuerdoSeleccionado,
  IArchivoAcuerdo,
} from "../../interfaces/acuerdos";
import { IArchivoAdjunto } from "../../interfaces/storage";

export const initialState: IAcuerdoSeleccionado = IStateAcuerdoSeleccionado;

export const acuerdoSeleccionadoReducer = createReducer(
  initialState,
  on(cargaTemasAcuerdo, (state, { acuerdoSeleccionado }) => {
    return {
      ...state,
      acuerdo: acuerdoSeleccionado.acuerdo,
      temas: acuerdoSeleccionado.temas,
      archivos: acuerdoSeleccionado.archivos,
      status: acuerdoSeleccionado.status,
      statusTema: acuerdoSeleccionado.statusTema ?? "",
      ultimoTemaGuardado: acuerdoSeleccionado.ultimoTemaGuardado ?? null,
    };
  }),
  on(agregarNuevoTema, (state, { tema }) => ({
    ...state,
    temas: [...state.temas, tema],
  })),
  on(nuevosArchivosAcuerdo, (state, { files }) => ({
    ...state,
    archivos: [...state.archivos, ...(Array.isArray(files) ? files : [])],
  })),

  on(eliminarArchivoAcuerdo, (state, { file }) => ({
    ...state,
    archivos: state.archivos.filter(
      (archivo) => archivo.fileId !== file.fileId
    ),
  })),

  on(toggleExpandTema, (state, { id }) => ({
    ...state,
    temas: state.temas.map((tema) => ({
      ...tema,
      expanded: tema.id === id ? !tema.expanded : false,
    })),
  })),
  on(updateTemaForm, (state, { id, formValue }) => ({
    ...state,
    temas: state.temas.map((tema) =>
      tema.indiceTema === id ? { ...tema, ...formValue } : tema
    ),
  })),

  on(dragArchivosTema, (state, { idTema, idEntrada, archivos }) => ({
    ...state,
    temas: state.temas.map((tema) => {
      if (tema.id === idTema) {
        return {
          ...tema,
          entradas: tema.entradas.map((entrada) => {
            if (entrada.idEntrada === idEntrada) {
              return {
                ...entrada,
                archivos: archivos,
              };
            }
            return entrada;
          }),
        };
      }
      return tema;
    }),
  })),

  on(dragEntrregablesTema, (state, { idTema, idEntrada, entregables }) => ({
    ...state,
    temas: state.temas.map((tema) => {
      if (tema.id === idTema) {
        const nuevasEntradas = tema.entradas.map((entrada) => {
          if (entrada.id_entrada === idEntrada) {
            return {
              ...entrada,
              entregables: entregables,
            };
          }
          return entrada;
        });
        return {
          ...tema,
          entradas: nuevasEntradas,
        };
      }
      return tema;
    }),
  })),
  on(dragEntrada, (state, { idTema, entradas }) => ({
    ...state,
    temas: state.temas.map((tema) => {
      if (tema.id === idTema) {
        return {
          ...tema,
          entradas: entradas,
        };
      }
      return tema;
    }),
  })),

  on(agregarNuevaEntradaSuccess, (state, { temaId, entrada }) => ({
    ...state,
    temas: state.temas.map((tema) => {
      if (tema.id === temaId) {
        return {
          ...tema,
          expanded: true,
          entradas: [...tema.entradas, entrada],
        };
      }
      return tema;
    }),
  })),

  on(cargarEntregablesArchivosSuccess, (state, { archivosEntregables }) => ({
    ...state,
    temas: state.temas.map((tema) => {
      if (archivosEntregables.idTema === "") {
        return {
          ...tema,
          expanded: true,
          entradas: tema.entradas.map((entrada: any) => {
            if (entrada.idEntrada === archivosEntregables.idEntrada) {
              return {
                ...entrada,
                archivos: archivosEntregables.archivos,
                entregables: archivosEntregables.entregables,
              };
            } else {
              return {
                ...entrada,
              };
            }
          }),
        };
      }
      return tema;
    }),
  })),

  on(nuevoActualizarIndicacion, (state, { indicacion }) => ({
    ...state,
    temas: state.temas.map((tema) => {
      if (tema.id === indicacion.idTema) {
        const indicacionExistenteIndex = tema.indicacionesAB.findIndex(
          (i) => i.idIndicacion === indicacion.idIndicacion
        );

        if (indicacionExistenteIndex !== -1) {
          const updatedIndicaciones = [...tema.indicacionesAB];
          updatedIndicaciones[indicacionExistenteIndex] = indicacion;
          return {
            ...tema,
            expanded: true,
            indicacionesAB: updatedIndicaciones,
          };
        } else {
          return {
            ...tema,
            expanded: true,
            indicacionesAB: [...tema.indicacionesAB, indicacion],
          };
        }
      }
      return { ...tema, expanded: false };
    }),
  })),

  on(eliminarArchivoAdjunto, (state, { idTema, archivo }) => ({
    ...state,
    temas: state.temas.map((tema) => {
      if (tema.id === idTema) {
        return {
          ...tema,
          entradas: tema.entradas.map((entrada) => {
            if (entrada.idEntrada === archivo.id_entrada) {
              return {
                ...entrada,
                archivos: entrada.archivos.filter(
                  (file) => file.nombre_archivo !== archivo.nombre_archivo
                ),
              };
            }
            return entrada;
          }),
        };
      }
      return tema;
    }),
  })),

  on(eliminarEntrada, (state, { entrada }) => ({
    ...state,
    temas: state.temas.map((tema) => {
      if (tema.id === entrada.idTema) {
        return {
          ...tema,
          entradas: tema.entradas.filter(
            (entr) => entr.idEntrada !== entrada.idEntrada
          ),
        };
      }
      return tema;
    }),
  })),
  on(agregarEditarObservacionesAcuerdo, (state, { observaciones }) => ({
    ...state,
    acuerdo: { ...state.acuerdo, observaciones },
  })),
  on(realizarAcuerdo, (state, { esRealizado }) => ({
    ...state,
    acuerdo: { ...state.acuerdo, esRealizado },
  })),
  on(eliminarTemaMrb, (state, { temaStatus }) => ({
    ...state,
    temaStatus,
  })),

  on(resetTemasDejarAcuerdo, (state, { acuerdo }) => ({
    ...state,
    acuerdo,
    temas: [],
    archivos: [],
    status: "",
  })),
  on(resetTemasAcuerdo, () => {
    return initialState;
  }),
  on(updateFechaAcuerdo, (state, { fecha, acuerdo }) => {
    return {
      ...state,
      acuerdo: { ...state.acuerdo, fechaAcuerdo: fecha },
    };
  })
);
